import './announcement.css'
import './announcementShort.css'
import {AppleMusicLogo, BandcampLogo, InstaLogo, SpotifyLogo, TidalLogo, TikTokLogo, YouTubeLogo} from "../../img";
import React from "react";
import AnimLogo from "../animLogo/AnimLogo";
import AlbumCover from "../albumCover/AlbumCover";

const Announcement = (props) => {
  const {songName, URL, img} = props;

  return (
    <>
      {!['', 'bootloader'].includes(window.location.href.split('/')[window.location.href.split('/').length - 1]) ? <AnimLogo/> : <></>}
      <div className={'announcementText'}>
        <div>{songName !== 'BOOTLOADER' && songName}</div>
        <div>{songName === 'BOOTLOADER' ? '' : 'OUT NOW!'}</div>
        {/*{(URL === '' || URL === 'bootloader') && <a className={'btn preSaveBtn'} style={{borderImage: `url(${img}) 7 round`}}*/}
        {/*   href={`https://bloatware.bandcamp.com/album/bootloader`} target={"_blank"}>BUY NOW</a>}*/}
        {(URL === '' || URL === 'bootloader') && <iframe style={{border: 0, width: '275px', height: '550px'}}
                 src="https://bandcamp.com/EmbeddedPlayer/album=1804889200/size=large/bgcol=ffffff/linkcol=0687f5/transparent=true/"
                 seamless><a href="https://bloatware.bandcamp.com/album/bootloader">Bootloader by Bloatware</a>
        </iframe>}
        <a className={'btn preSaveBtn'} style={{borderImage: `url(${img}) 7 round`}}
           href={`https://distrokid.com/hyperfollow/bloatware/${URL}`} target={"_blank"}>LISTEN HERE</a>
        {/*<a className={'btn musicVideoBtn'}*/}
        {/*   href={'https://www.youtube.com/watch?v=bbv10y5mxJI'}>MUSIC VIDEO</a>*/}
        <div className={'socialContainer'}>
          <a className={'btn socialBtn bandcampBtn'} rel={"noreferrer"}
             href={'https://bloatware.bandcamp.com/'}
             target={"_blank"}>
            <img className={'socialImg bandcampLogo'} src={BandcampLogo} alt={'Bandcamp logo'}/>
          </a>
          <a className={'btn socialBtn spotifyBtn'} rel={"noreferrer"}
             href={'https://open.spotify.com/artist/79LPtRg7hftiiUbmeBM3r0?si=X5RCwhVcQJeJCNV3v_4sbA'}
             target={"_blank"}>
            <img className={'socialImg spotifyLogo'} src={SpotifyLogo} alt={'Spotify logo'}/>
          </a>
          <a className={'btn socialBtn tidalBtn'} rel={"noreferrer"}
             href={'https://tidal.com/artist/36543618/u'}
             target={"_blank"}>
            <img className={'socialImg tidalLogo'} src={TidalLogo} alt={'Tidal logo'}/>
          </a>
          <a className={'btn socialBtn appleMusicBtn'} rel={"noreferrer"}
             href={'https://music.apple.com/gb/artist/bloatware/1726459110'}
             target={"_blank"}>
            <img className={'socialImg appleMusicLogo'} src={AppleMusicLogo} alt={'Apple Music logo'}/>
          </a>
          <a className={'btn socialBtn youtubeBtn'} rel={"noreferrer"}
             href={'https://www.youtube.com/@BloatwareSounds'}
             target={"_blank"}>
            <img className={'socialImg youtubeLogo'} src={YouTubeLogo} alt={'YouTube logo'}/>
          </a>
          <a className={'btn socialBtn instaBtn'} rel={"noreferrer"}
             href={'https://instagram.com/bloatwaresounds'} target={"_blank"}>
            <img className={'socialImg instaLogo'} src={InstaLogo} alt={'Instagram logo'}/>
          </a>
          <a className={'btn socialBtn tikTokBtn'} rel={"noreferrer"}
             href={'https://www.tiktok.com/@bloatwaresounds'} target={"_blank"}>
            <img className={'socialImg tikTokLogo'} src={TikTokLogo} alt={'TikTok logo'}/>
          </a>
        </div>
      </div>
    </>
  )
}

export default Announcement;